import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=3a5372a8"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a5372a8')) {
      api.createRecord('3a5372a8', component.options)
    } else {
      api.reload('3a5372a8', component.options)
    }
    module.hot.accept("./Slider.vue?vue&type=template&id=3a5372a8", function () {
      api.rerender('3a5372a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/core/components/Slider.vue"
export default component.exports